import { useParams } from 'react-router-dom';
import useIsJiraIntegrationActive from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/useIsJiraIntegrationActive';
import NRActiveVulnerabilityJiraTickets from './NRActiveVulnerabilityJiraTickets';

function NRVulnerabilityJiraTickets({ advisoryId, vulnerabilityData, cveDetails, sx }) {
  const { componentId: assetId } = useParams();
  const { isJiraIntegrationActive, isJiraIntegrationLoading } = useIsJiraIntegrationActive();

  if (!isJiraIntegrationActive || isJiraIntegrationLoading || !assetId || !advisoryId || !vulnerabilityData?.componentId) {
    return null;
  }

  return (
    <NRActiveVulnerabilityJiraTickets
      advisoryId={advisoryId}
      assetId={assetId}
      vulnerabilityData={vulnerabilityData}
      cveDetails={cveDetails}
      sx={sx}
    />
  );
}

export default NRVulnerabilityJiraTickets;
